import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Form, Menu, message } from 'antd';
import Input from '../../../text-field/index';
import TextComponent from '@sharedComponent/typography/TextComponent';
import '../deliverycard.scss';

const CdtPage = ({ navigateDisabled }) => {
	const [payrollName, setPayrollName] = useState('');
	const [payrollMobile, setPayrollMobile] = useState('');
	const [payrollEmail, setPayrollEmail] = useState('');
	const [allow, setAllow] = useState(false);
	const [errorMsgList, setErrorMsgList] = useState({
		nameerr: '',
		MobileNumbererr: '',
		Emailerr: '',
	});
	let regEmail =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	const [cardNumberinfo, setNumberInfo] = useState([
		{ num: '1', msg: 'Using our money transfer and mobile recharge services on the C3Pay app.' },
		{ num: '2', msg: 'Card Usage' },
		{ num: '3', msg: 'Financial safety and fraud prevention.' },
	]);

	const onFinish = () => {
		if (payrollName && payrollMobile && payrollEmail && allow) {
			navigateDisabled(false);
		} else {
			navigateDisabled(true);
		}
	};
	const validateMessages = (changeValue, allValue) => {
		if (allValue.MobileNumber && allValue.MobileNumber.replace(/[^0-9]/g, '').length !== 8) {
			setAllow(false);
		} else if (allValue.Email && !regEmail.test(allValue.Email)) {
			setAllow(false);
		} else {
			setAllow(true);
		}
	};

	const validateForm = (e) => {
		if (e.target.name == 'MobileNumber') {
			if (payrollMobile.length > 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, MobileNumbererr: 'Mobile Number must be within 8 digits' };
				});
			} else if (payrollMobile.length < 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, MobileNumbererr: 'Mobile Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, MobileNumbererr: '' };
				});
			}
		}

		if (e.target.name == 'Email') {
			if (!regEmail.test(payrollEmail)) {
				setErrorMsgList((prevState) => {
					return { ...prevState, Emailerr: 'Email is not Valid' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, Emailerr: '' };
				});
			}
		}
	};

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
				<TextComponent className="medium">Card Distribution and Training</TextComponent>
				<div style={{ marginTop: '20px' }}>
					{/* <TextComponent className="text">We will visit your employees' accommodation for free and train them on:</TextComponent> */}
					<TextComponent className="text2" style={{ marginTop: '10px' }}>
						<p>We will visit your employees' accommodation for free and train them on:</p>
					</TextComponent>
				</div>
				<div style={{ marginTop: '20px' }}>
					{cardNumberinfo.map((res, index) => (
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
							<div className="cardNumber_container">
								<div className="number_card">
									<TextComponent className="medium">{res.num}</TextComponent>
								</div>
							</div>
							<div className="cardNumber_description_container">
								<TextComponent style={{ marginTop: index > 0 ? '7px' : 'none' }} className="delivery_card_step_text">
									<p>{res.msg}</p>
								</TextComponent>
							</div>
						</div>
					))}
				</div>
				<div style={{ marginTop: '20px', marginBottom: '20px' }}>
					<TextComponent className="medium">Point of contact and Accommodation</TextComponent>
				</div>
				<div>
					<Form onFinish={onFinish()} onValuesChange={validateMessages} className="contactInfoFormWrapper">
						<Form.Item name="Name" initialValue={''}>
							<div className="global_input_Container">
								<Input
									name="Name"
									type="text"
									labels={
										<span>
											Name <text style={{ color: 'red' }}>*</text>
										</span>
									}
									value={payrollName}
									onBlur={validateForm}
									onChange={(e) => setPayrollName(e.target.value.replace(/[^A-Za-z ]/gi, ''))}
								/>
								<div>
									<TextComponent className="errorText">{errorMsgList.nameerr}</TextComponent>
								</div>
							</div>
						</Form.Item>
						<Form.Item name="MobileNumber">
							<div className="global_input_Container">
								<Input
									name="MobileNumber"
									type="text"
									labels={
										<span>
											Mobile Number <text style={{ color: 'red' }}>*</text>
										</span>
									}
									value={payrollMobile}
									onBlur={validateForm}
									onChange={(e) => setPayrollMobile(e.target.value.replace(/[^0-9]/g, ''))}
								/>
								<div>
									<TextComponent className="errorText">{errorMsgList.MobileNumbererr}</TextComponent>
								</div>
							</div>
						</Form.Item>
						<Form.Item name="Email" initialValue={''}>
							<div className="global_input_Container">
								<Input
									name="Email"
									type="text"
									onBlur={validateForm}
									labels={
										<span>
											Email ID <text style={{ color: 'red' }}>*</text>
										</span>
									}
									onChange={(e) => setPayrollEmail(e.target.value)}
									value={payrollEmail}
								/>
								<div>
									<TextComponent className="errorText">{errorMsgList.Emailerr}</TextComponent>
								</div>
							</div>
						</Form.Item>
					</Form>
				</div>
			</div>
		</>
	);
};

export default CdtPage;
